import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeSignReceiptCommand } from './serialize';

/** POST `…/{id}/complete`：ESTABLISHED → COMPLETED。 */
export async function completeSignReceipt(id, payload) {
  const { data: raw } = await request.post(
    `/aftersales/sign-receipt/${id}/complete`,
    serializeSignReceiptCommand(payload),
  );
  return parseVer4DetailResponse(raw);
}
